import { useEffect } from 'react';
import type { ContractRelevantTransferOfUsesResponse } from 'src/apis/contract-management/types';
import type { ContractTerminationConsequencesRequest } from 'src/apis/contract-management/use-contract-termination-consequences';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  contractTerminationConsequences: ContractTerminationConsequencesRequest;
};

export function useContractRelevantTransferOfUses({
  contractTerminationConsequences,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: { url: string }) =>
      axios.request<ContractRelevantTransferOfUsesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!contractTerminationConsequences.response) return;
    const url =
      contractTerminationConsequences.response.data._links
        .relevantTransfersOfUse.href;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [contractTerminationConsequences.response]);

  return request;
}

export type ContractRelevantTransferOfUsesRequest = ReturnType<
  typeof useContractRelevantTransferOfUses
>;
